import { Loader2Icon } from "lucide-react"

import { cn } from "@/lib/utils"
import { useAutoTranslation } from "@/entities"
import { LANG_KEYS } from "@/shared/constants"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const { t } = useAutoTranslation()
  return (
    <Loader2Icon
      role="status"
      aria-label={t(LANG_KEYS.LOADING)}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
